import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SiteMap from "../components/SiteMap";
import { Box, Typography, Button } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";

const DOC_URL = "https://www.infosind.com.br/diario-oficial/login/55955464";

const DiarioOficial = () => {
    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <Box
                    marginY={4}
                    paddingX={isMobile ? 2 : 8}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={2}
                >
                    <Typography
                        component="h1"
                        color="#010101"
                        width={"fit-content"}
                        borderBottom={1}
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="800"
                        fontSize="20px"
                        lineHeight="23px"
                    >
                        Diário Oficial da Cidade
                    </Typography>
                    <Typography
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="500"
                        fontSize="16px"
                        lineHeight="22px"
                        color="#202020"
                    >
                        Consulta ao Diário Oficial da Cidade exclusiva para filiados do Sindsep.
                        Caso a página abaixo não carregue, utilize o botão para abrir em uma nova aba.
                    </Typography>
                    <Button
                        component="a"
                        href={DOC_URL}
                        target="_blank"
                        rel="noreferrer"
                        startIcon={<OpenInNew />}
                        sx={{
                            alignSelf: "flex-start",
                            backgroundColor: "#C81E1E",
                            color: "#FFFFFF",
                            borderRadius: 100,
                            padding: "9px 19px",
                            fontFamily: "Raleway",
                            fontWeight: 600,
                            fontSize: "14px",
                            "&:hover": { backgroundColor: "#a51818" },
                        }}
                    >
                        Abrir em nova aba
                    </Button>
                    <Box
                        sx={{
                            width: "100%",
                            height: isMobile ? "70vh" : "80vh",
                            border: "1px solid #EAECF0",
                            borderRadius: "8px",
                            overflow: "hidden",
                            marginTop: 2,
                        }}
                    >
                        <iframe
                            src={DOC_URL}
                            title="Diário Oficial da Cidade - Consulta do filiado"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </Box>
                </Box>
            </main>
            <footer>
                <Footer />
                <SiteMap />
            </footer>
        </>
    );
};

export default DiarioOficial;
